const TRIM_TOOLS_CDN_URL = `${process.env.NEXT_PUBLIC_CDN_URL}`;
const SHARED_CDN_URL = `${process.env.NEXT_PUBLIC_SHARED_CDN_URL}`;

export const CHECK_ICON_URL = `${TRIM_TOOLS_CDN_URL}/check.svg`;

const HERO = {
  heading: {
    heading1: 'Online for ',
    heading2: 'Free',
  },
  highlightedText: 'Trim and Cut Video ',
  image: {
    url: `${TRIM_TOOLS_CDN_URL}/v2_hero-2x.png`,
    alt: 'Hero',
  },
  desktop: {
    buttonLabel: 'Upload your video to start',
    subInfo: 'Files up to 800 MB',
  },
  mobile: {
    subInfo: 'Visit us on your desktop computer to use Quick tools',
    CTAText: 'Get the link',
    inputPlaceholder: 'Enter your email',
  },
};

const GUIDE = {
  title: 'How to trim a video',
  buttonLabel: 'Upload your video to start',
  cards: [
    {
      heading: {
        heading1: 'Upload your ',
        heading2: 'video file',
      },
      description: `Click the ‘Upload your video to start’ button and select your file. We support all common video formats and files up to 800 MB.`,
      image: {
        url: `${TRIM_TOOLS_CDN_URL}/guide1_v1.png`,
        alt: 'Media',
      },
      bgImage: {
        desktop: {
          defaultUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-desktop_1x-1.png`,
          webpUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-desktop_1x-1.webp`,
          name: `${TRIM_TOOLS_CDN_URL}/v1-guide-desktop_1x-1.png`,
          alt: 'Media',
        },
        tablet: {
          defaultUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-tablet_1x-1.png`,
          webpUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-tablet_1x-1.webp`,
          name: `${TRIM_TOOLS_CDN_URL}/v1-guide-tablet_1x-1.png`,
          alt: 'Media',
        },
        mobile: {
          defaultUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-mobile_1x-1.png`,
          webpUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-mobile_1x-1.webp`,
          name: `${TRIM_TOOLS_CDN_URL}/v1-guide-mobile_1x-1.png`,
          alt: 'Media',
        },
      },
    },
    {
      heading: {
        heading1: 'Trim to desired ',
        heading2: 'length',
      },
      description: `Trim your video clip to the desired start and end points. For extra precision, you can manually enter in and out times.`,
      image: {
        url: `${TRIM_TOOLS_CDN_URL}/guide2_v1.png`,
        alt: 'Media',
      },
      bgImage: {
        desktop: {
          defaultUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-desktop_1x-2.png`,
          webpUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-desktop_1x-2.webp`,
          name: `${TRIM_TOOLS_CDN_URL}/v1-guide-desktop_1x-2.png`,
          alt: 'Media',
        },
        tablet: {
          defaultUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-tablet_1x-2.png`,
          webpUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-tablet_1x-2.webp`,
          name: `${TRIM_TOOLS_CDN_URL}/v1-guide-tablet_1x-2.png`,
          alt: 'Media',
        },
        mobile: {
          defaultUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-mobile_1x-2.png`,
          webpUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-mobile_1x-2.webp`,
          name: `${TRIM_TOOLS_CDN_URL}/v1-guide-mobile_1x-2.png`,
          alt: 'Media',
        },
      },
    },
    {
      heading: {
        heading1: 'Download ',
        heading2: 'for free',
      },
      description: `Click the ‘Done’ button when you are happy with the edits and download your watermark free video.`,
      image: {
        url: `${TRIM_TOOLS_CDN_URL}/guide3_v1.png`,
        alt: 'Media',
      },
      bgImage: {
        desktop: {
          defaultUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-desktop_1x-3.png`,
          webpUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-desktop_1x-3.webp`,
          name: `${TRIM_TOOLS_CDN_URL}/v1-guide-desktop_1x-3.png`,
          alt: 'Media',
        },
        tablet: {
          defaultUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-tablet_1x-3.png`,
          webpUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-tablet_1x-3.webp`,
          name: `${TRIM_TOOLS_CDN_URL}/v1-guide-tablet_1x-3.png`,
          alt: 'Media',
        },
        mobile: {
          defaultUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-mobile_1x-3.png`,
          webpUrl: `${TRIM_TOOLS_CDN_URL}/v1-guide-mobile_1x-3.webp`,
          name: `${TRIM_TOOLS_CDN_URL}/v1-guide-mobile_1x-3.png`,
          alt: 'Media',
        },
      },
    },
  ],
};

const whys = [
  {
    image: {
      desktop: {
        url: `${TRIM_TOOLS_CDN_URL}/Smile.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Smile.svg`,
        alt: 'Smile',
        width: 55.5,
        height: 55.5,
      },
      tablet: {
        url: `${TRIM_TOOLS_CDN_URL}/Smile.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Smile.svg`,
        alt: 'Smile',
        width: 48.56,
        height: 48.56,
      },
      mobile: {
        url: `${TRIM_TOOLS_CDN_URL}/Smile.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Smile.svg`,
        alt: 'Smile',
        width: 31.22,
        height: 31.22,
      },
    },
    title: 'Quick and easy to use',
    highlightedContent: 'Trim your video with only a few clicks, ',
    plainContent:
      'within a minute and with no previous video editing knowledge.',
  },
  {
    image: {
      desktop: {
        url: `${TRIM_TOOLS_CDN_URL}/VideoFormats.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/VideoFormats.svg`,
        alt: 'Video Formats',
        width: 42.5,
        height: 53.5,
      },
      tablet: {
        url: `${TRIM_TOOLS_CDN_URL}/VideoFormats.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/VideoFormats.svg`,
        alt: 'Video Formats',
        width: 37.19,
        height: 46.81,
      },
      mobile: {
        url: `${TRIM_TOOLS_CDN_URL}/VideoFormats.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/VideoFormats.svg`,
        alt: 'Video Formats',
        width: 23.91,
        height: 30.09,
      },
    },
    title: 'Supports all video formats',
    highlightedContent: 'We support all popular video formats ',
    plainContent: 'like MP4, WebM and many others.',
  },
  {
    image: {
      desktop: {
        url: `${TRIM_TOOLS_CDN_URL}/Security.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Security.svg`,
        alt: 'Security',
        width: 40.5,
        height: 54.5,
      },
      tablet: {
        url: `${TRIM_TOOLS_CDN_URL}/Security.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Security.svg`,
        alt: 'Security',
        width: 35.44,
        height: 47.69,
      },
      mobile: {
        url: `${TRIM_TOOLS_CDN_URL}/Security.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Security.svg`,
        alt: 'Security',
        width: 22.78,
        height: 30.66,
      },
    },
    title: 'Enterprise-grade security',
    highlightedContent: 'Being secure is what we do.  ',
    plainContent:
      'We protect your data with enterprise-grade security, which means that your videos are just for you to see.',
  },
  {
    image: {
      desktop: {
        url: `${TRIM_TOOLS_CDN_URL}/Cloud.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Cloud.svg`,
        alt: 'Cloud',
        width: 55.5,
        height: 39.5,
      },
      tablet: {
        url: `${TRIM_TOOLS_CDN_URL}/Cloud.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Cloud.svg`,
        alt: 'Cloud',
        width: 48.56,
        height: 34.56,
      },
      mobile: {
        url: `${TRIM_TOOLS_CDN_URL}/Cloud.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Cloud.svg`,
        alt: 'Cloud',
        width: 31.22,
        height: 22.22,
      },
    },
    title: 'Online',
    highlightedContent: 'Our video trimmer works completely online, ',
    plainContent:
      'it is browser-based, and doesn’t require any software to be downloaded.',
  },
  {
    image: {
      desktop: {
        url: `${TRIM_TOOLS_CDN_URL}/Free.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Free.svg`,
        alt: 'Free',
        width: 55.5,
        height: 55.5,
      },
      tablet: {
        url: `${TRIM_TOOLS_CDN_URL}/Free.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Free.svg`,
        alt: 'Free',
        width: 48.56,
        height: 48.56,
      },
      mobile: {
        url: `${TRIM_TOOLS_CDN_URL}/Free.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/Free.svg`,
        alt: 'Free',
        width: 31.22,
        height: 31.22,
      },
    },
    title: 'Completely free',
    highlightedContent:
      'With invideo quick tools you can perform simple video edits ',
    plainContent:
      'like cutting, trimming, cropping, and similar actions, with only a few clicks and no previous video editing experience needed.',
  },
  {
    image: {
      desktop: {
        url: `${TRIM_TOOLS_CDN_URL}/NoWatermark.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/NoWatermark.svg`,
        alt: 'No Watermark',
        width: 55,
        height: 58,
      },
      tablet: {
        url: `${TRIM_TOOLS_CDN_URL}/NoWatermark.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/NoWatermark.svg`,
        alt: 'No Watermark',
        width: 48.12,
        height: 50.75,
      },
      mobile: {
        url: `${TRIM_TOOLS_CDN_URL}/NoWatermark.svg`,
        name: `${TRIM_TOOLS_CDN_URL}/NoWatermark.svg`,
        alt: 'No Watermark',
        width: 30.94,
        height: 32.62,
      },
    },
    title: 'No watermark',
    highlightedContent:
      'Your creations can be downloaded without a watermark, ',
    plainContent: 'in full video resolution. ',
  },
];

const FeatureSection = {
  plainTitle: `Why use invideo's `,
  highlightedTitle: 'Online Video Cutter?',
  image: {
    url: `${TRIM_TOOLS_CDN_URL}/v1_feature.png`,
    alt: 'Trim',
  },
  whys,
};

const FAQ = {
  title: 'Frequently Asked Questions for Online Video Trimmer',
  items: [
    {
      heading: 'How do I trim a video clip online?',
      description: [
        {
          type: 'text',
          text: `Quick tools video trimmer lets you remove the ends of your video. To trim a video all you need to do is upload your video file and move the blue handles of the clip to the desired position on the timeline.`,
        },
        {
          type: 'newLineText',
          text: `For precise control, you can manually enter in and out times of the clip to the decimal precision. In time represents the time stamp where you would like your clip to start. Similarly, out time represents the time stamp where you would like your clip to end. In and out times manipulation would have the same result as moving the handles of the clip.`,
        },
      ],
    },
    {
      heading:
        'What is the difference between cut video vs. trim vs. crop video?',
      description: [
        {
          type: 'text',
          text: `‘Trim’ video and ‘Cut’ video refer to editing the duration of a video clip, ie. making it shorter. ‘Crop’ a video refers to removing part of the video’s image`,
        },
      ],
    },
    {
      heading: 'What video file types can I export from Quick tools?',
      description: [
        {
          type: 'text',
          text: `Quick tools support exporting videos in various file types such as: MP4, MOV, WebM, AVI, QuickTime, and others. With a few clicks, export your video optimized for social media.`,
        },
      ],
    },
    {
      heading: 'How long should my video be?',
      description: [
        {
          type: 'text',
          text: `Quick tools are intended for shorter videos, mainly for social media. For example Instagram Reel videos can only be 15 seconds long and TikTok videos can be up to 1 minute. Quick tools are perfect for these kind of edits. If you would like to do more professional editing, with plenty of pro features, you can use our invideo full featured editor.`,
        },
      ],
    },
    {
      heading: 'How to trim a video on iPhone or Android?',
      description: [
        {
          type: 'text',
          text: `Quick tools are supported for your laptop or desktop computer, but if you would like to trim a video on your mobile device, you can `,
        },
        {
          type: 'link',
          url: 'https://filmrapp.onelink.me/9iEj/99c7fdb8',
          text: 'download Filmr',
        },
        {
          type: 'text',
          text: ' - our mobile video editing app.',
        },
      ],
    },
  ],
  icons: {
    collapse: `${TRIM_TOOLS_CDN_URL}/rounded-close.svg`,
    expand: `${TRIM_TOOLS_CDN_URL}/rounded-open.svg`,
  },
};

const PROMOTION = {
  plainTitle: {
    line1: 'For advanced edits ',
    line2: 'try the ',
  },
  highlightedTitle: 'invideo editor',
  buttonLabel: 'Get started - it’s free!',
  subInfo: 'No credit card required',
  paragraph: 'Try invideo’s full-featured video editor. ',
  highlightedParagraph:
    'It comes power packed with 5000+ customizable templates, video stock footage from iStock, filters and everything else that you need.',
  image: {
    url: `${TRIM_TOOLS_CDN_URL}/v1_promotion.png`,
    alt: 'Editor',
  },
  link: 'https://invideo.io/workflow/marketing-templates',
};

export const APP_PROMO_BANNER = {
  crossIcon: `${SHARED_CDN_URL}/header-icons/cross.svg`,
  iconText: 'Filmr',
  gradientClass: 'iv-gradient-blue-deepblue-raspberry',
  heading: 'Edit videos on the go',
  subHeading: 'with invideo companion mobile app',
  buttonLabel: {
    iOS: 'Download on the App store',
    Android: 'Download on the Play store',
  },
  icon: {
    url: `${SHARED_CDN_URL}/header-icons/angle-right-blue.svg`,
    alt: 'angle right',
    width: 4,
    height: 7,
  },
};

export const EDITOR = {
  image: {
    width: 330,
    height: 250,
    alt: 'Editor',
    url: `${TRIM_TOOLS_CDN_URL}/v1_editor-light.png`,
  },
  logo: {
    width: 37,
    height: 37,
    alt: 'invideo logo',
    url: `${SHARED_CDN_URL}/logos/green_logo.svg`,
  },
};

export const TRIM_TOOL = {
  WHYs: FeatureSection,
  FAQ,
  HERO,
  PROMOTION,
  GUIDE,
};

export enum HeadingStyleType {
  Plain = 'Plain',
  Highlighted = 'Highlighted',
}
